export const TRANSLATIONS_PT_SHELL_AND_COMMON = {
  "notifications.title": "Notificações",
  "notifications.markAllRead": "Marcar todas como lidas",
  "navbar.brand": "Sistema RAG",
  "nav.home": "Início",
  "nav.expandSidebar": "Expandir barra lateral",
  "nav.collapseSidebar": "Recolher barra lateral",
  "nav.notifications": "Notificações",
  "nav.userMenu": "Menu do usuário",
  "nav.help": "Ajuda",
  "nav.chat": "Chat",
  "nav.upload": "Enviar Documentos",
  "nav.dashboard": "Painel",
  "nav.profile": "Perfil",
  "nav.settings": "Preferências",
  "nav.logout": "Sair",
  "nav.query": "Consulta",
  "nav.about": "Sobre",
  "nav.tasks": "Tarefas",
  "nav.plan": "Plano",
  "plan.tabs.overview": "Meu plano",
  "plan.tabs.detail": "Detalhes",
  "auth.login": "Entrar",
  "auth.or": "ou",
  "auth.signup": "Registrar-se",
  "auth.powered_by": "Desenvolvido por",
  " ": "Duplo clique para baixar",
  "common.close": "Fechar",
  "common.options": "Opções",
  "common.cancel": "Cancelar",
  "nav.documents": "Documentos",
  "header.help": "Ajuda",
  "header.theme.switchToLight": "Mudar para tema claro",
  "header.theme.switchToDark": "Mudar para tema escuro",
  "role.admin": "Administrador",
  "role.user": "Usuário",
  "footer.rights": "Todos os direitos reservados.",
  "footer.terms": "Termos de serviço",
  "footer.privacy": "Política de privacidade",
  "footer.contact": "Contato",
  "auth.create_account": "Criar conta",
  "auth.signup_description": "Crie uma conta para começar",
  "auth.back_to_login": "Voltar ao login",
  "auth.loading": "Carregando...",
  "auth.redirecting": "Redirecionando...",
  "nav.admin": "Admin",
  "notifications.empty": "Sem notificações",
  "role.executive": "Executivo",
  "common.yes": "Sim",
  "common.no": "Não",
  "breadcrumbs.input.label": "Local do arquivo",
  "breadcrumbs.popover.create_option": "Criar pasta",
  "breadcrumbs.modal.label": "Nome da pasta",
  "breadcrumbs.modal.button.cancel": "Cancelar",
  "breadcrumbs.modal.button.create": "Criar",
  "common.save": "Salvar",
  "common.email": "E-mail",
  "common.role": "Função",
  "common.created": "Criado",
  "common.actions": "Ações",
  "common.page": "Página",
  "common.of": "de",
  "common.prev": "Anterior",
  "common.next": "Próximo",
  "common.status": "Status",
  "common.name": "Nome",
  "common.records": "registros",
  "common.inactive": "Inativo",
  "common.activate": "Ativar",
  "common.deactivate": "Desativar",
  "common.sending": "Enviando...",
  "errors.email_required": "E-mail é obrigatório.",
  "errors.email_invalid": "Formato de e-mail inválido.",
  "errors.role_required": "Função é obrigatória.",
  "nav.generate": "Documentos Gerados",
  "nav.knowledge": "Conhecimento",
  "nav.changes": "Alterações",
  "nav.alerts": "Alertas",
  "nav.knowledgeHub": "Knowledge Hub",
};
